import {
  COPY_REFERENCE_CLICKED_ACTION_TYPE,
  COPY_REFERENCE_DISPLAYED_ACTION_TYPE,
  COPY_REFERENCE_FEEDBACK_REASON_CLICKED_ACTION_TYPE,
} from 'components/CopyReferenceFeedback/CopyReferenceFeedback.types';
import { CROSS_SELLING_ADD_TO_BASKET_TRACKED as CROSS_SELLING_ADD_TO_BASKET_TRACKED_ACTION_TYPE } from 'domains/basket/Basket.types';
import { CROSS_SELLING_MODULE_DISPLAYED_TRACKED } from 'domains/crossSelling/CrossSelling.types';
import { WS_NAMESPACE } from 'domains/webSockets/WebSocket.types';

/**
 * Actions that should never be tracked — prevents feedback loops
 * and avoids tracking internal WebSocket infrastructure actions.
 */
const EXCLUDED_ACTION_PREFIXES: string[] = [WS_NAMESPACE];

/**
 * Whitelisted actions that should be tracked
 */
const FILTER_ACTIONS: Set<string> = new Set([
  COPY_REFERENCE_DISPLAYED_ACTION_TYPE,
  COPY_REFERENCE_CLICKED_ACTION_TYPE,
  COPY_REFERENCE_FEEDBACK_REASON_CLICKED_ACTION_TYPE,
  CROSS_SELLING_ADD_TO_BASKET_TRACKED_ACTION_TYPE,
  CROSS_SELLING_MODULE_DISPLAYED_TRACKED,
]);

export function shouldTrackAction(actionType: string): boolean {
  if (EXCLUDED_ACTION_PREFIXES.some((prefix) => actionType.startsWith(prefix))) {
    return false;
  }
  return FILTER_ACTIONS.has(actionType);
}
